module.exports = __webpack_public_path__ + "static/img/img-textcloud.1e5e62b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-textcloud.png
// module id = gqZM
// module chunks = 1